import {
  BookkeepersManagementPayrollResultsDocument,
  BookkeepersManagementPayrollResultsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

export type BookkeepersManagementPayrollResultsQueryData =
  BookkeepersManagementPayrollResultsQuery['payroll']['policyPeriods'][number]

const useGetPayrollResults = () => {
  const { selectedCompany: filterContextCompany, filterDate } = useIncidenceFilterContext()
  const selectedCompany = filterContextCompany?.attributes.id
  const isBookkeeperView = useBookkeeperView()

  const { loading, data } = useQuery(BookkeepersManagementPayrollResultsDocument, {
    variables: {
      companyIds: selectedCompany,
      periodEndsOn: filterDate.lastDate,
      periodStartsOn: filterDate.firstDate,
      status: [PayrollStatus.PAYROLL_CALCULATION],
    },
    context: {
      isBookkeeperView,
    },
  })

  return {
    loading,
    payrollResults: data?.payroll?.policyPeriods || [],
  }
}

export default useGetPayrollResults
